import { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {useTheme} from '@mui/material';
import { miliToGram, numberToTomans } from '../../utils/helpers';

const GoldBoxWidget = ({totalGold, totalMoney, goldPriceSell}) => {
    const [isVisible, setIsVisible] = useState(true);
    const theme = useTheme();
    
    const handleVisibilityClick = () => {
        setIsVisible((prev) => !prev);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: "100%",
                padding: '10px',
                margin: '12px',
                borderRadius: '12px',
                background: theme.gradients.gold,
                boxShadow: 'none',
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', flex:1, alignItems: 'center', justifyContent: 'center' }}>
                <Box
                    sx={{ display: 'flex', flexDirection: 'row', width:'100%'}}
                >
                    <Typography
                        variant='caption2'
                        sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start'}}
                    >
                        موجودی صندوقچه
                    </Typography>
                    <IconButton
                        size="small"
                        onClick={handleVisibilityClick}
                        sx={{
                            color: theme.palette.text.default,
                            padding: "0 6px"
                        }}
                    >
                        {isVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                </Box>
                <Typography
                    variant='caption'
                    color='textDark'
                    sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', width: '100%'}}
                >
                    {isVisible ? `${miliToGram(totalGold)} گرم` : '******'}
                </Typography>
                <Typography
                    variant='caption2'
                    sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', width: '100%'}}
                >
                    معادل
                </Typography>
                <Typography
                    variant='subtitle'
                    color='textDark'
                    sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', width: '100%'}}
                >
                    {isVisible ? `${numberToTomans(totalMoney)} تومان` : '******'}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', flex:1, alignSelf: 'flex-end',alignItems: 'center', justifyContent: 'center' }}>
                <Typography
                    variant='subtitle2'
                    sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', width: '100%'}}
                >
                    قیمت لحظه‌ای فروش گرم طلا
                </Typography>
                <Typography
                    variant='subtitle'
                    color='textDark'
                    sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', width: '100%'}}
                >
                    {`${numberToTomans(goldPriceSell)} تومان`}
                </Typography>
            </Box>
        </Box>
    );
};

export default GoldBoxWidget;
